(function () {
  var SECTION_SELECTOR = '.oddit-section-recommended-products';
  var sectionState = new Map();

  function setupScrollBar(section) {
    var track = section.querySelector('.oddit-section-recommended-products__track');
    var scrollBar = section.querySelector('.oddit-section-recommended-products__scroll-bar');
    var progress = section.querySelector('.oddit-section-recommended-products__scroll-progress');

    if (!track || !scrollBar || !progress) return;

    // Tear down any previous wiring (e.g. content was re-injected).
    destroySection(section);

    var state = {
      track: track,
      progress: progress,
      scrollBar: scrollBar,
      resizeObserver: null,
      onScroll: null
    };

    function updateProgress() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) {
        // No overflow — grid layout (desktop). Hide the scroll bar.
        scrollBar.style.display = 'none';
        return;
      }
      scrollBar.style.display = '';

      var visibleRatio = Math.max(0.1, Math.min(1, track.clientWidth / track.scrollWidth));
      var scrolledRatio = max > 0 ? track.scrollLeft / max : 0;
      var trackWidth = scrollBar.clientWidth;
      var thumbWidth = trackWidth * visibleRatio;
      var maxTranslate = trackWidth - thumbWidth;
      var translateX = maxTranslate * scrolledRatio;

      progress.style.width = thumbWidth + 'px';
      progress.style.transform = 'translateX(' + translateX + 'px)';
    }

    function onScroll() {
      window.requestAnimationFrame(updateProgress);
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    state.onScroll = onScroll;

    if (typeof ResizeObserver !== 'undefined') {
      state.resizeObserver = new ResizeObserver(function () {
        updateProgress();
      });
      state.resizeObserver.observe(track);
    }

    // Initial paint
    window.requestAnimationFrame(updateProgress);

    sectionState.set(section, state);
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (!state) return;
    if (state.onScroll) state.track.removeEventListener('scroll', state.onScroll);
    if (state.resizeObserver) state.resizeObserver.disconnect();
    sectionState.delete(section);
  }

  // The global reveal IntersectionObserver (oddit-interactions.js) only observes
  // nodes that exist at its init, so AJAX-injected cards never animate in. The
  // content is already in view by the time it is fetched, so set the stagger
  // indices and reveal it directly.
  function revealInjected(section) {
    section.querySelectorAll('[data-oddit-stagger]').forEach(function (container) {
      var idx = 0;
      Array.prototype.forEach.call(container.children, function (child) {
        if (child.classList && child.classList.contains('oddit-reveal')) {
          child.style.setProperty('--oddit-stagger-index', String(idx));
          idx += 1;
        }
      });
    });
    section.querySelectorAll('.oddit-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function loadRecommendations(section) {
    var url = section.getAttribute('data-recommendations-url');
    if (!url) {
      // Already rendered server-side (via the recommendations route) — just wire up.
      setupScrollBar(section);
      return;
    }

    // Prevent a re-fetch if init runs again before this resolves.
    section.removeAttribute('data-recommendations-url');

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations request failed');
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fetched = doc.querySelector(SECTION_SELECTOR);
        if (!fetched) return;

        var newContainer = fetched.querySelector('.oddit-section-recommended-products__container');
        var currentContainer = section.querySelector('.oddit-section-recommended-products__container');

        if (newContainer && currentContainer) {
          currentContainer.innerHTML = newContainer.innerHTML;
        } else {
          section.innerHTML = fetched.innerHTML;
        }

        // No recommendations came back — leave the section empty.
        if (!section.querySelector('.oddit-section-recommended-products__track')) return;

        revealInjected(section);
        setupScrollBar(section);
      })
      .catch(function () {
        /* Network/parse failure — leave the section as-is. */
      });
  }

  function initSection(section) {
    if (!section) return;

    // Recommendations already present (rendered via the route) — just wire the scroll bar.
    if (section.querySelector('.oddit-section-recommended-products__track')) {
      setupScrollBar(section);
      return;
    }

    if (!section.getAttribute('data-recommendations-url')) return;

    if (!('IntersectionObserver' in window)) {
      loadRecommendations(section);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        loadRecommendations(section);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    observer.observe(section);
  }

  function initAll() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor hooks
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
